import { useParams } from 'react-router-dom';

import AuditHistoryAccordion from './AuditHistoryAccordion';
import Layout from './Layout';
import { useGetDepositSourcingAudit } from './hooks';

export default function DepositSourcingAuditHistory() {
  const { assetId, pageEnum } = useParams();

  const {
    data: auditHistory,
    isLoading,
    isError,
  } = useGetDepositSourcingAudit(assetId);

  return (
    <Layout
      pageEnum={pageEnum}
      isLoading={isLoading}
      isError={isError}
      isDataEmpty={!auditHistory?.length}
    >
      <AuditHistoryAccordion data={auditHistory} />
    </Layout>
  );
}
